<template>
     <header class="page__header">
        <div class="header" :class="{'header--extended': isExtended}">
            <div class="header-content">
                <div class="header-content__inner">
                    <div class="header-content__logo">
                        <router-link :to="{name: 'PageStart'}">
                            <img src="@/assets/img/logo.png" alt="Velbert zeigt Herz">
                        </router-link>
                    </div>
                    <div class="header-content__actions">
                        <button
                            @click.prevent="navigateTo({name: 'PageStart', hash: '#projects-overview'})"
                            class="btn btn--green anchor"
                        >
                            <strong>
                                Projekte ansehen
                            </strong>
                        </button>
                        <button
                            @click.prevent="navigateTo({name: 'PageStart', hash: '#submit-project'})"
                            class="btn btn--yellow anchor"
                        >
                            <strong>
                                Projekt einreichen
                            </strong>
                        </button>
                        <!-- code box start -->
                        <code-box />
                        <!-- code box end -->
                    </div>
                    <div class="header-content__media">
                        <div class="media-info">
                            <router-link :to="{name: 'Imprint'}">
                                Kontakt & Impressum
                            </router-link>
                        </div>
                        <div class="media-networks" >
                            <a :href="shareLinks.wa" target="_blank" title="WhatsApp teilen">
                                <span class="mdi mdi-whatsapp" aria-hidden="true"></span>
                            </a>
                            <a :href="shareLinks.fb" target="_blank" title="Facebook teilen">
                                <span class="mdi mdi-facebook" aria-hidden="true"></span>
                            </a>
                            <a :href="shareLinks.li" target="_blank" title="LinkedIn teilen">
                                <span class="mdi mdi-linkedin" aria-hidden="true"></span>
                            </a>
                        </div>
                    </div>
                    <div class="header-content__menu-trigger">
                        <span class="mdi mdi-menu"></span>
                    </div>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
import ShareLinks from '@/mixins/ShareLinks'
import NavigateTo from '@/mixins/NavigateTo'
import CodeBox from '@/components/CodeBox'

export default {
    name: 'PageHeader',

    mixins: [
        ShareLinks,
        NavigateTo
    ],

    components: {
        CodeBox
    },

    mounted () {
        if (!this.canExtend) {
            return
        }

        // get scroll pos one time
        this.getScrollPosition()
        // Listen to scroll changes
        this.addScrollListener()
    },

    data () {
        return {
            scroll: 0
        }
    },

    watch: {
        $route (route) {
            if (this.canExtend) {
                // get scroll pos one time
                this.getScrollPosition()
                // Listen to scroll changes
                return this.addScrollListener()
            }

            this.removeScrollListener()
        }
    },

    computed: {
        canExtend () {
            return this.$route.name === 'PageStart'
        },

        isExtended () {
            return this.canExtend && this.scroll === 0
        }

    },

    methods: {
        addScrollListener () {
            window.addEventListener('scroll', this.getScrollPosition)
        },

        removeScrollListener () {
            window.removeEventListener('scroll', this.getScrollPosition)
        },

        getScrollPosition () {
            this.scroll = window.pageYOffset
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/PageHeader.vue